// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-details {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.api-details h2 {
  font-weight: 500;
}

.custom-underline {
  background-color: #635ad9;
  width: 60px;
  height: 2px;
  margin-top: 5px;
}

.header-div {
  position: absolute;
  width: 100%;
  height: 350px;
  top: 0;
  left: 0;
  background-color: #17012c;
  padding: 0;
  z-index: 1000;
  overflow: hidden;
}

.header {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.image-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.dark-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, 
    rgba(23, 1, 44, 0.5),     /* Matches your background color with 50% opacity at top */
    rgba(23, 1, 44, 0.85)     /* Darker at bottom for better text visibility */
  );
  z-index: 1;
}

.header img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header-nav {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 0.5rem;
  color: white;
  z-index: 2;
  margin-bottom: 1rem;
  position: relative;  /* Added to ensure z-index works */
}

.advantage-container {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0 18px 0;
}

.advantage-container-two {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 30px 0;
}

.advantage {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.advantage > span {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.advantage > span > span:first-child {
  display: flex;
  align-items: center;
}

.advantage-two {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.advantage-two > span {
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.advantage-two > span > span:first-child {
  display: flex;
  align-items: center;
}

.advantage-two > span > .title-desc-container {
  display: inline;
}

.advantage-two > span .title-text {
  font-weight: 600;
  margin-right: 0.25rem;
}

.check-icon {
  width: 16px;
  height: 16px;
  color: red;
}

.launch-desc {
  margin-top: 4rem;
}

.launch-desc h2 {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

.main-container {
  width: 100%;
  display: flex;
  gap: 2rem;
}

/* Travel API Page */
.travel-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.travel-img-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 372px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.travel-img-container img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}

/* DMT Page */
.dmt-container {
  height: 100%;
  padding: 30px 0 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}

.dmt-card {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  justify-items: center;
  align-items: center;
  gap: 2rem;
}

/* BBPS CSS */
.bbps-first-div {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.bbps-two-div {
  /* background-color: #ECF8FF; */
  /* padding: 1rem; */
  border-radius: 8px;
  margin: 4rem 0 4rem 0;
  /* margin-top: 1.75rem; */
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.payout-two-div {
  border-radius: 8px;
  margin: 5rem 0 5rem 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 2rem;
}

.bbps-details {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.bbps-links {
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;
  /* justify-content: center; */
}

.bbps-links a {
  color: #635ad9;
  text-decoration: none;
}

.logo {
  width: 42px;
  height: 42px;
}

/* Payout API CSS */
.contact-buttons {
  margin-top: 20px;
}
.contact-buttons button {
  margin-right: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
.contact-buttons button:hover {
  background-color: #0056b3;
}

.payout-div-one {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: 2rem;
}

.offbit {
  background-color: rgb(245, 244, 244);
  padding: 2rem 1rem 2rem 1rem;
  border-radius: 8px;
  margin: 4rem 0 4rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-evenly;
  align-items: center;
}
.inner-offbit {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.offbit img {
  width: 8rem;
  height: 8rem;
}

.offbit p {
  text-align: center;
  font-weight: 600;
  margin-top: 1.5rem;
  font-size: 1.2rem;
}

.counter-wrap,
.ct-heading,
.sec-title4,
.service-wrap.style3 .container {
  position: relative;
  z-index: 1;
}

.bg-rock,
.process .item .cont:hover {
  background-color: #635ad9;
  padding: 1rem;
  border-radius: 12px;
}

.ptb-100 {
  padding-top: 40px;
  padding-bottom: 70px;
}

.service-wrap.style3 .container .service-shape-one {
  position: absolute;
  top: 100px;
  right: -10px;
  z-index: -1;
}
.service-wrap.style3 .container .service-shape-two {
  position: absolute;
  bottom: 100px;
  left: -35px;
  z-index: -1;
}

.serviceBox-payout {
  color: #635ad9;
  font-family: "Zen Maru Gothic", sans-serif;
  text-align: center;
  padding: 30px 35px 40px;
  border-radius: 0 80px;
  border: 2px dashed #fff;
  position: relative;
  z-index: 1;
  margin-bottom: 30px;
}
.serviceBox-payout:before {
  content: "";
  background: #fff;
  border-radius: 0 70px;
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.3);
  transform: translateX(-50%) translateY(-50%);
  position: absolute;
  width: calc(100% - 15px);
  height: calc(100% - 15px);
  top: 50%;
  left: 50%;
  z-index: -1;
}
.serviceBox-payout .service-icon {
  font-size: 45px;
  margin: 0 auto 15px;
}
.serviceBox-payout .title {
  font-size: 20px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0 0 12px;
}
.serviceBox-payout .description {
  color: #444;
  font-size: 14px;
  line-height: 22px;
}
.serviceBox-payout.yellow {
  color: #d38a0c;
  border-color: #d38a0c;
}
.serviceBox-payout.yellow:after {
  background-color: #d38a0c;
  height: 130px;
  width: 100px;
  border-radius: 0 0 0 80px;
  top: auto;
  bottom: -9px;
}
.serviceBox-payout.purple {
  color: #8455d0;
  border-color: #8455d0;
}
.serviceBox-payout.purple:after {
  background-color: #8455d0;
  top: auto;
  bottom: -9px;
  left: auto;
  right: -9px;
}
.serviceBox-payout.red {
  color: #cd4b4c;
  border-color: #cd4b4c;
}
.serviceBox-payout.red:after {
  background-color: #cd4b4c;
  width: 100px;
  height: 130px;
  border-radius: 0 85px 0 0;
  left: auto;
  right: -9px;
}

.section-title-grid {
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(300px, 1fr)
  ); /* Responsive grid with a minimum column size */
  gap: 2rem;
  /* padding: 1rem; */
}

.section-title h2 {
  text-align: center;
  color: white;
  padding: 2rem 0 2rem 0;
}

.main-why-div {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 2rem 0 2rem 0;
  gap: 2rem;
}

.why-img-div {
  width: 100%;
  height: 100%;
}

.why-img-div img {
  width: 100%;
  height: auto;
}

.why-option-div {
  width: 100%;
  display: flex;
  gap: 1rem;
}

.why-btn-div {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.why-btn-div-button {
  background-color: white;
  border: none;
  text-align: left;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
}

.why-btn-div-active-button {
  background-color: #635ad9;
  color: white;
  border: none;
  text-align: left;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
}

.why-line {
  width: 1px;
    height: 100%;
    background-color: gray;
  display: none;
}

/* Pan Card Page CSS */
.pan-header-card-one {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.pan-card-div-one {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 3rem 0 3rem 0;
}

.pan-card-div-one-rev {
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
  padding: 3rem 0 3rem 0;
}

.img-div img {
  width: 100%;
  height: auto;
}

.pan-card-main-header p {
  padding: 0.5rem 0 0.5rem 0;
  font-size: 14px;
}

@media only screen and (max-width: 990px) {
  .serviceBox {
    margin: 0 0 30px;
  }
  .serviceBox-payout {
    margin: 0 0 30px;
  }
}

@media (min-width: 640px) {
  .advantage-container {
    flex-direction: row;
  }
  .dmt-card {
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem;
  }
  .bbps-details {
    flex-direction: row;
  }
  .section-title-grid {
    padding: 1rem;
  }
  .why-line {
    display: block;
  }
}

@media (min-width: 1024px) {
}

@media (min-width: 1280px) {
  .advantage-container-two {
    flex-direction: row;
  }
  .dmt-container {
    flex-direction: row;
  }
  .bbps-first-div {
    flex-direction: row;
  }
  .payout-div-one {
    flex-direction: row;
  }
  .payout-two-div {
   flex-direction: row;
  }
  .bbps-two-div {
    flex-direction: column;
  }
  .main-why-div {
    flex-direction: row;
  }
  .pan-card-div-one {
    flex-direction: row;
  }
  .pan-card-div-one-rev {
    flex-direction: row;
  }
}

@media (min-width: 1536px) {
  .bbps-two-div {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ApiServices/api.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;GAGC;EACD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,kBAAkB,GAAG,kCAAkC;AACzD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,SAAS;EACT,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,4CAA4C;EAC5C,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,YAAY;AACd;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;AACb;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb;;;GAGC,EAAE,+CAA+C;EAClD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;IACR,YAAY;IACZ,sBAAsB;EACxB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;AACA;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;GACC,mBAAmB;EACpB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".api-details {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.api-details h2 {\n  font-weight: 500;\n}\n\n.custom-underline {\n  background-color: #635ad9;\n  width: 60px;\n  height: 2px;\n  margin-top: 5px;\n}\n\n.header-div {\n  position: absolute;\n  width: 100%;\n  height: 350px;\n  top: 0;\n  left: 0;\n  background-color: #17012c;\n  padding: 0;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.header {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.image-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.dark-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(to bottom, \n    rgba(23, 1, 44, 0.5),     /* Matches your background color with 50% opacity at top */\n    rgba(23, 1, 44, 0.85)     /* Darker at bottom for better text visibility */\n  );\n  z-index: 1;\n}\n\n.header img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.header-nav {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  gap: 0.5rem;\n  color: white;\n  z-index: 2;\n  margin-bottom: 1rem;\n  position: relative;  /* Added to ensure z-index works */\n}\n\n.advantage-container {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  padding: 18px 0 18px 0;\n}\n\n.advantage-container-two {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px 0 30px 0;\n}\n\n.advantage {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.advantage > span {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.advantage > span > span:first-child {\n  display: flex;\n  align-items: center;\n}\n\n.advantage-two {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.advantage-two > span {\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.advantage-two > span > span:first-child {\n  display: flex;\n  align-items: center;\n}\n\n.advantage-two > span > .title-desc-container {\n  display: inline;\n}\n\n.advantage-two > span .title-text {\n  font-weight: 600;\n  margin-right: 0.25rem;\n}\n\n.check-icon {\n  width: 16px;\n  height: 16px;\n  color: red;\n}\n\n.launch-desc {\n  margin-top: 4rem;\n}\n\n.launch-desc h2 {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\n.main-container {\n  width: 100%;\n  display: flex;\n  gap: 2rem;\n}\n\n/* Travel API Page */\n.travel-container {\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n}\n\n.travel-img-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 372px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n\n.travel-img-container img {\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n  object-fit: cover;\n}\n\n/* DMT Page */\n.dmt-container {\n  height: 100%;\n  padding: 30px 0 30px 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n}\n\n.dmt-card {\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  justify-items: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n/* BBPS CSS */\n.bbps-first-div {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 2rem;\n}\n\n.bbps-two-div {\n  /* background-color: #ECF8FF; */\n  /* padding: 1rem; */\n  border-radius: 8px;\n  margin: 4rem 0 4rem 0;\n  /* margin-top: 1.75rem; */\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.payout-two-div {\n  border-radius: 8px;\n  margin: 5rem 0 5rem 0;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.bbps-details {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  align-items: center;\n  gap: 2rem;\n}\n\n.bbps-links {\n  margin-top: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: center;\n  /* justify-content: center; */\n}\n\n.bbps-links a {\n  color: #635ad9;\n  text-decoration: none;\n}\n\n.logo {\n  width: 42px;\n  height: 42px;\n}\n\n/* Payout API CSS */\n.contact-buttons {\n  margin-top: 20px;\n}\n.contact-buttons button {\n  margin-right: 10px;\n  padding: 10px 20px;\n  background-color: #007bff;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n.contact-buttons button:hover {\n  background-color: #0056b3;\n}\n\n.payout-div-one {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  gap: 2rem;\n}\n\n.offbit {\n  background-color: rgb(245, 244, 244);\n  padding: 2rem 1rem 2rem 1rem;\n  border-radius: 8px;\n  margin: 4rem 0 4rem 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  justify-content: space-evenly;\n  align-items: center;\n}\n.inner-offbit {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.offbit img {\n  width: 8rem;\n  height: 8rem;\n}\n\n.offbit p {\n  text-align: center;\n  font-weight: 600;\n  margin-top: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.counter-wrap,\n.ct-heading,\n.sec-title4,\n.service-wrap.style3 .container {\n  position: relative;\n  z-index: 1;\n}\n\n.bg-rock,\n.process .item .cont:hover {\n  background-color: #635ad9;\n  padding: 1rem;\n  border-radius: 12px;\n}\n\n.ptb-100 {\n  padding-top: 40px;\n  padding-bottom: 70px;\n}\n\n.service-wrap.style3 .container .service-shape-one {\n  position: absolute;\n  top: 100px;\n  right: -10px;\n  z-index: -1;\n}\n.service-wrap.style3 .container .service-shape-two {\n  position: absolute;\n  bottom: 100px;\n  left: -35px;\n  z-index: -1;\n}\n\n.serviceBox-payout {\n  color: #635ad9;\n  font-family: \"Zen Maru Gothic\", sans-serif;\n  text-align: center;\n  padding: 30px 35px 40px;\n  border-radius: 0 80px;\n  border: 2px dashed #fff;\n  position: relative;\n  z-index: 1;\n  margin-bottom: 30px;\n}\n.serviceBox-payout:before {\n  content: \"\";\n  background: #fff;\n  border-radius: 0 70px;\n  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.3);\n  transform: translateX(-50%) translateY(-50%);\n  position: absolute;\n  width: calc(100% - 15px);\n  height: calc(100% - 15px);\n  top: 50%;\n  left: 50%;\n  z-index: -1;\n}\n.serviceBox-payout .service-icon {\n  font-size: 45px;\n  margin: 0 auto 15px;\n}\n.serviceBox-payout .title {\n  font-size: 20px;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin: 0 0 12px;\n}\n.serviceBox-payout .description {\n  color: #444;\n  font-size: 14px;\n  line-height: 22px;\n}\n.serviceBox-payout.yellow {\n  color: #d38a0c;\n  border-color: #d38a0c;\n}\n.serviceBox-payout.yellow:after {\n  background-color: #d38a0c;\n  height: 130px;\n  width: 100px;\n  border-radius: 0 0 0 80px;\n  top: auto;\n  bottom: -9px;\n}\n.serviceBox-payout.purple {\n  color: #8455d0;\n  border-color: #8455d0;\n}\n.serviceBox-payout.purple:after {\n  background-color: #8455d0;\n  top: auto;\n  bottom: -9px;\n  left: auto;\n  right: -9px;\n}\n.serviceBox-payout.red {\n  color: #cd4b4c;\n  border-color: #cd4b4c;\n}\n.serviceBox-payout.red:after {\n  background-color: #cd4b4c;\n  width: 100px;\n  height: 130px;\n  border-radius: 0 85px 0 0;\n  left: auto;\n  right: -9px;\n}\n\n.section-title-grid {\n  display: grid;\n  grid-template-columns: repeat(\n    auto-fit,\n    minmax(300px, 1fr)\n  ); /* Responsive grid with a minimum column size */\n  gap: 2rem;\n  /* padding: 1rem; */\n}\n\n.section-title h2 {\n  text-align: center;\n  color: white;\n  padding: 2rem 0 2rem 0;\n}\n\n.main-why-div {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin: 2rem 0 2rem 0;\n  gap: 2rem;\n}\n\n.why-img-div {\n  width: 100%;\n  height: 100%;\n}\n\n.why-img-div img {\n  width: 100%;\n  height: auto;\n}\n\n.why-option-div {\n  width: 100%;\n  display: flex;\n  gap: 1rem;\n}\n\n.why-btn-div {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.why-btn-div-button {\n  background-color: white;\n  border: none;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 0.5rem;\n}\n\n.why-btn-div-active-button {\n  background-color: #635ad9;\n  color: white;\n  border: none;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n}\n\n.why-line {\n  width: 1px;\n    height: 100%;\n    background-color: gray;\n  display: none;\n}\n\n/* Pan Card Page CSS */\n.pan-header-card-one {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.pan-card-div-one {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 3rem 0 3rem 0;\n}\n\n.pan-card-div-one-rev {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: space-between;\n  align-items: center;\n  gap: 2rem;\n  padding: 3rem 0 3rem 0;\n}\n\n.img-div img {\n  width: 100%;\n  height: auto;\n}\n\n.pan-card-main-header p {\n  padding: 0.5rem 0 0.5rem 0;\n  font-size: 14px;\n}\n\n@media only screen and (max-width: 990px) {\n  .serviceBox {\n    margin: 0 0 30px;\n  }\n  .serviceBox-payout {\n    margin: 0 0 30px;\n  }\n}\n\n@media (min-width: 640px) {\n  .advantage-container {\n    flex-direction: row;\n  }\n  .dmt-card {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 4rem;\n  }\n  .bbps-details {\n    flex-direction: row;\n  }\n  .section-title-grid {\n    padding: 1rem;\n  }\n  .why-line {\n    display: block;\n  }\n}\n\n@media (min-width: 1024px) {\n}\n\n@media (min-width: 1280px) {\n  .advantage-container-two {\n    flex-direction: row;\n  }\n  .dmt-container {\n    flex-direction: row;\n  }\n  .bbps-first-div {\n    flex-direction: row;\n  }\n  .payout-div-one {\n    flex-direction: row;\n  }\n  .payout-two-div {\n   flex-direction: row;\n  }\n  .bbps-two-div {\n    flex-direction: column;\n  }\n  .main-why-div {\n    flex-direction: row;\n  }\n  .pan-card-div-one {\n    flex-direction: row;\n  }\n  .pan-card-div-one-rev {\n    flex-direction: row;\n  }\n}\n\n@media (min-width: 1536px) {\n  .bbps-two-div {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
